import { render, staticRenderFns } from "./DriverInformation.vue?vue&type=template&id=150c8464&lang=pug&"
import script from "./DriverInformation.vue?vue&type=script&lang=ts&"
export * from "./DriverInformation.vue?vue&type=script&lang=ts&"
import style0 from "./DriverInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports